<template>
  <!-- eslint-disable-next-line vue/no-undef-components -->
  <AuthBackground>
    <slot />
  </AuthBackground>
</template>
